import React from 'react';
import { Fragment } from 'react';
import Card from '../Card/Card';

function ServicesCard() {
  return (
    <Fragment>
      <Card
        title='تقديم الحملات الاعلانية على جميع المنصات'
      // description='كتابة ابحاث اكاديمية وعلمية ودراسات في كافة المجالات وفق الاسس العلمية المعتمدة .'
      />

      <Card
        title='ادارة صفحات السوشيال ميديا'
      // description='الترجمة باللغتين العربية والانجليزية وبشكل احترافي .'
      />

      <Card
        title='كتابة محتوى ابداعي'
      // description=' خدمات التدقيق المحاسبي والتدقيق الضريبي للشركات وخدمات ادارية ومعالجات مالية، اعداد دراسات الجدوى وإعداد القوائم المالية بشكل كامل.'
      />

      <Card
        title='وضع خطط واستراتيجيات ناجحة بالتسويق الالكتروني'
      // description='كتابة محتوى متنوع في كافة المجالات ومتوافق مع SEO'
      />

      <Card
        title='انشاء قناوت يوتيوب وتقديم خطط تسويقية وحل المشكلات'
      // description='تصميمات بأعلى مستوى من الاحتراف والكفاءة والجودة والإبداع الناتج عن
      // تدفق الأفكار الإبداعية'
      />

      <Card
        title='انشاء هويات بصرية للعلامات التجارية'
      // description='تصاميم مختلفة لاختيار شكل الموقع بالهوية المناسبة .'
      />

      <Card
        title='اعداد وتصميم فيديو الموشن جيرافيك'
      // description=' تقود الاكاديمية عملية تطوير تطبيقات الأجهزة المحمولة بالكامل من الفكرة إلى
      // التسليم ، وإلى الدعم المستمر.'
      />

      <Card
        title='تصميم جيرافيكي'
      // description='تطوير وتصميم مواقع وتطبيقات الويب بدورة كاملة , نحن نقدم خدمات تطوير
      // الويب المتكاملة.'
      />
    </Fragment>
  );
}

export default ServicesCard;
